export const donutSettings = (defaultSettings: { [ key: string ]: unknown }[], environmentLink: string) => {
    return [
        [
            ...defaultSettings,
            {
                name: 'LayoutChart',
                title: 'Layout',
                isShowTitle: false,
                icon: environmentLink + '/assets/images/Options/settings-dark.svg',
                hasDrop: true,
                dropWidth: 'medium',
                removePadding: true,
                controls: [
                    {
                        controlName: 'Toggle',
                        property: 'showLegend',
                        title: 'Legend',
                        defaultValue: false,
                        separateLine: false,
                        padding: ' 16px',
                        margin: '0'
                    },
                    {
                        controlName: 'ImageSelect',
                        property: 'legendPosition',
                        title: '',
                        defaultValue: 1,
                        showTitle: false,
                        padding: '0 16px',
                        condition: { showLegend: true },
                        presetData: [
                            {
                                title: '',
                                icon: environmentLink + '/assets/images/Layout-top.svg',
                                value: 'top',
                                width: 50
                            },
                            {
                                title: '',
                                icon: environmentLink + '/assets/images/Layout-bottom.svg',
                                value: 'bottom',
                                width: 50
                            }
                        ]
                    },
                    {
                        controlName: 'Toggle',
                        property: 'showAnnotation',
                        title: 'Annotation',
                        defaultValue: false,
                        separateLine: false,
                        separateLineTop: true,
                        padding: '16px',
                        margin: '0'
                    },
                    {
                        controlName: 'ImageSelect',
                        property: 'annotationPosition',
                        title: '',
                        defaultValue: 1,
                        showTitle: false,
                        padding: '0 16px',
                        condition: { showAnnotation: true },
                        isValuesInsideBox: true,
                        useTitle: true,
                        presetData: [
                            {
                                title: 'Outside',
                                value: 'outside',
                                width: 50
                            },
                            {
                                title: 'Inside',
                                value: 'inside',
                                width: 50
                            }
                        ]
                    },
                    {
                        controlName: 'Slider',
                        title: 'Donut size',
                        property: 'donutSize',
                        separateLineTop: true,
                        defaultValue: 70,
                        suffix: '%',
                        min: 10,
                        max: 70,
                        padding: '16px',
                        margin: '0'
                    },
                    {
                        controlName: 'InputText',
                        property: 'prefix',
                        title: 'Prefix',
                        defaultValue: '$',
                        separateLine: true,
                        separateLineTop: true,
                        padding: '16px',
                        margin: '0',
                        inline: true
                    },
                    {
                        controlName: 'InputText',
                        property: 'suffix',
                        title: 'Suffix',
                        defaultValue: 'M',
                        separateLine: false,
                        padding: '16px',
                        margin: '0',
                        inline: true
                    }
                ],
            }
        ],
        [
            {
                name: 'animation',
                title: 'Animated chart',
                isShowTitle: false,
                icon: environmentLink + '/assets/images/Options/animation.svg',
                hasDrop: true,
                dropWidth: 'medium',
                removePadding: true,
                controls: [
                    {
                        controlName: 'Toggle',
                        property: 'animation',
                        title: 'Animated chart',
                        defaultValue: false,
                        separateLine: false,
                        padding: ' 16px',
                        margin: '0'
                    },
                ]
            },
            {
                settingName: 'Anchor',
            }
        ]
    ]
}